<template>
  <div>
    <div class="card softblue">
      <div class="card-body">
        <div class="media">
          <img :src="userInfo.picture_path ? userInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
          <div class="media-body">
            <span class="badge rose">학생</span>
            <h5>{{userInfo.name}}</h5>
            <span>{{userInfo.school_name}} {{userInfo.id}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-0">
            <h2>공지사항</h2>
          </div>
        </div>
      </div>
      <stone-data-table
        :loading="searchLoading"
        :columns="noticeColumns"
        :data="noticeData"
        :table-props="noticeProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps"
        @row-click="noticeRowClickHandler">
      </stone-data-table>
    </div>

    <notice ref="notice" width="95%"></notice>

  </div>

</template>

<script>

import common from '@/modules/common'
import notice from '@/pages/components/Notice.vue'

export default {
  name: 'S010301',
  components: {notice},
  mixins: [common.mixins],
  data () {
    return {
      viewMode: false,
      noticeData: [],
      noticeColumns: [
        {label: '작성일', prop: 'reg_dt', align: 'center'},
        {label: '제목', prop: 'title', align: 'left'}
      ],
      noticeProps: {},
      userInfo: {
        picture_path: '',
        name: '',
        id: '',
        school_name: ''
      }
    }
  },
  created () {
    this.loadUserInfo()
    this.retreiveNotice()
  },
  methods: {
    loadUserInfo () {
      common.axios.get('/user/load/' + this.$store.getters.user_seq)
        .then(response => {
          const result = response.data
          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
        })
    },
    retreiveNotice () {
      this.loadStoneDataTable('/board/notice/user/' + this.$store.getters.user_seq, null, false)
        .then(response => {
          this.noticeData = response.data
        })
        .catch(() => {
        })
    },
    noticeRowClickHandler (row) {
      this.handleNoticeDiallogLoad(row.board_seq)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/S010301.vue